import { withStyles } from '@mui/styles';
import Typography from '@mui/material/Typography';
import Button from '@mui/material/Button';
import { useNavigate } from '@reach/router';

// types and classes
import type { $TSFixMe, GenericObject } from '@calefy-inc/utilityTypes';

interface BaseMissingQuoteErrorProps {
  uuid: string;
  classes: GenericObject;
}
export const BaseMissingQuoteError = ({
  uuid,
  classes = {},
}: BaseMissingQuoteErrorProps) => {
  const navigate = useNavigate();
  const quoteLocation = '/insurtech/manager/quotes';

  return (
    <div className={classes.outerContainer} data-testid='Missing Quote Error'>
      <div className={classes.main}>
        <Typography variant='h6' color='primary' className={classes.title}>
          No Application Found
        </Typography>

        <Typography
          variant='body2'
          color='textSecondary'
          className={classes.content}
        >
          There is no application, either complete or incomplete, associated
          with the unique identifier {uuid}. If you believe that you are
          receiving this message in error, please contact us at{' '}
          <a
            href={`mailto:support@calefy.ca?subject=Application ${uuid} error`}
          >
            support@calefy.ca
          </a>
          .
        </Typography>

        <Button
          variant='contained'
          sx={{ alignSelf: 'center' }}
          onClick={() => navigate(quoteLocation)}
        >
          Return to Applications
        </Button>
      </div>
    </div>
  );
};

export const MissingQuoteError = withStyles((theme) => ({
  outerContainer: {
    margin: `${theme.spacing(2)} 0`,
    justifyContent: 'center',
    alignSelf: 'center',
  },
  main: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    maxWidth: '40rem',
    minHeight: '60vh',
    margin: 'auto',
  },
  title: {
    marginTop: theme.spacing(2),
    marginBottom: theme.spacing(1.5),
    textAlign: 'center',
  },
  content: {
    textAlign: 'left',
    marginBottom: theme.spacing(2),
  },
}))((props: $TSFixMe) => <BaseMissingQuoteError {...props} />);
